// Skill icons
import flutter from "../assets/flutter.png";
import react from "../assets/react.png";
import node from "../assets/node.png";
import python from "../assets/python.png";
import javascript from "../assets/javascript.png";
import github from "../assets/github.png";
import tailwind from "../assets/tailwind.png";
import html from "../assets/html.png";
import php from "../assets/php.png";
import laravel from "../assets/laravel.png";
import postgresql from "../assets/postgresql.png";
import mysql from "../assets/mysql.png";
import css from "../assets/css.png";
import csharp from "../assets/csharp.png";
import awsS3 from "../assets/aws-s3.png";
import digitalocean from "../assets/digitalocean.png";
import godaddy from "../assets/godaddy.png";
import vuejs from "../assets/vuejs.png";
import linux from "../assets/linux.png";

// Project images
import cabinetSupplyJa from "../assets/cabinet-supply-ja.jpg";
import risto from "../assets/risto.jpg";
import negrilMuayThai from "../assets/negril-muay-thai.jpg";
import forexJa from "../assets/forex-ja.jpg";

// Background images
import vscode from "../assets/vscode.jpg";
import officDesk from "../assets/office-desk.jpg";

// Logo
import logo from "../assets/logo-no-border.png";

// Resume
import resume from "../assets/Reinaldo Pino Resume 2026.pdf";
import resumeAts from "../assets/Reinaldo Pino Resume 2026 (ATS).pdf";

export const skillIcons = {
  flutter,
  react,
  node,
  python,
  javascript,
  github,
  tailwind,
  html,
  php,
  laravel,
  postgresql,
  mysql,
  css,
  csharp,
  "aws-s3": awsS3,
  digitalocean,
  godaddy,
  vuejs,
  linux,
};

export const projectImages = {
  "cabinet-supply-ja": cabinetSupplyJa,
  risto,
  "negril-muay-thai": negrilMuayThai,
  "forex-ja": forexJa,
};

export const backgroundImages = {
  vscode,
  "office-desk": officDesk,
};

export { logo, resume, resumeAts };
